import { render, staticRenderFns } from "./AddSupplierPage.vue?vue&type=template&id=3841ab8f"
import script from "./AddSupplierPage.vue?vue&type=script&lang=js"
export * from "./AddSupplierPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports